import { isMobileOnly } from 'react-device-detect';
import { Box } from '@mui/material';

import { classes, Video, VideoMobile } from './styles';

const HomeBottomButtonOptionsCamView = () => (
  <Box component="div" sx={isMobileOnly ? classes.rootMobile : classes.root}>
    {isMobileOnly ? (
      <VideoMobile autoPlay playsInline id="videoElement" />
    ) : (
      <Video autoPlay playsInline id="videoElement" />
    )}
  </Box>
);

export default HomeBottomButtonOptionsCamView;
